import * as _ from 'lodash'
import * as $ from 'jquery'

function findTarget($element: any): any {
  const target = $element.data('target')
  if (_.startsWith(target, '#')) {
    return $(target)
  } else {
    return $element.closest(target)
  }
}

function handleResponse($element: any, data: any) {
    if (!$element.data('xhrml')) { return }
    $element.removeData('xhrml')
    $element.data('type', 'xhrml')

    const $target = findTarget($element)
    if ($element.data("replacement") == true) {
      const $html = $(data)
      $target.replaceWith($html)
      $html.trigger('xhrml:success')
      $html.trigger('content:loading')
      $html.trigger('content:loaded')
    } else {
      $target.html(data)
      $target.trigger('xhrml:success')
      $target.trigger('content:loading')
      $target.trigger('content:loaded')
    }
}

$(document).on({
  'ajax:before'(event) {
    const $element = $(event.target)
    if ($element.data('type') !== 'xhrml') { return }

    $element.data('type', 'html')
    $element.data('xhrml', true)

    const paramSelector = $element.data("param-selector")
    if (paramSelector != null) {
      const $form = $element.closest("form")
      const data = $form.find(paramSelector).serialize()
      $element.data("params", data)
    }
    true
  },
  'ajax:success'(event, data) {
    const $element = $(event.target)
    handleResponse($element, data)
  },
  'ajax:error'(event, xhr) {
    const $element = $(event.target)
    handleResponse($element, xhr.responseText)
  }
})
